"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIdle = void 0;

var React = __importStar(require("react"));

var throttle_debounce_1 = require("throttle-debounce");

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var utils_2 = require("./utils");

var defaultEvents = ['mousemove', 'mousedown', 'resize', 'keydown', 'touchstart', 'wheel'];
var onMinute = 60e3;

function useIdle(ms, initialState, events) {
  if (ms === void 0) {
    ms = onMinute;
  }

  if (initialState === void 0) {
    initialState = false;
  }

  if (events === void 0) {
    events = defaultEvents;
  }

  var _a = React.useState(initialState),
      state = _a[0],
      setState = _a[1];

  React.useEffect(function () {
    if (utils_1.isBrowser) {
      var mounted_1 = true,
          timeout_1,
          localState_1 = state;

      var set_1 = function set_1(nextState) {
        if (mounted_1) {
          localState_1 = nextState;
          setState(nextState);
        }
      };

      var onEvent_1 = throttle_debounce_1.throttle(50, function () {
        if (localState_1) {
          setState(false);
        }

        clearTimeout(timeout_1);
        timeout_1 = setTimeout(function () {
          set_1(true);
        }, ms);
      });

      var onVisibility_1 = function onVisibility_1() {
        if (!document.hidden) {
          onEvent_1();
        }
      };

      for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
        var eventName = events_1[_i];
        utils_2.on(window, eventName, onEvent_1);
      }

      utils_2.on(document, 'visibilitychange', onVisibility_1);
      timeout_1 = setTimeout(function () {
        set_1(true);
      }, ms);
      return function cleanup() {
        mounted_1 = false;

        for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
          var eventName = events_2[_i];
          utils_2.off(window, eventName, onEvent_1);
        }

        utils_2.off(document, 'visibilitychange', onVisibility_1);
      };
    }
  }, [ms, events]);
  return state;
}

exports.useIdle = useIdle;